export const projects = [
  {
    title: 'Medilab Manager',
    description: 'E-commerce for clinical examination laboratories with a patient-friendly interface and administration panel',
    gif: 'img/medilab-manager.gif',
    techs: ['javascript', 'react', 'redux', 'postgre', 'sequelize', 'node', 'express', 'jwt', 'mui', 'html5', 'css3', 'vercel'],
    deploy: 'https://medilab-manager.vercel.app',
    repository: 'https://github.com/NazarenoCarlesso/medilab-manager'
  },
  {
    title: 'Pokemon Pokedex',
    description: 'Learn about your favorite Pokémons in our Pokedex to be a better pokémon master',
    gif: 'img/pokemon-pokedex.gif',
    techs: ['javascript', 'react', 'redux', 'postgre', 'sequelize', 'node', 'express', 'mui', 'html5', 'css3', 'vercel'],
    deploy: 'https://pokemon-pokedex-nazarenocarlesso.vercel.app',
    repository: 'https://github.com/NazarenoCarlesso/pokemon'
  },
  {
    title: 'Rick and Morty',
    description: 'Find your favorite Rick and Morty characters and build a deck with collectionable cards',
    gif: 'img/rick-and-morty.gif',
    techs: ['javascript', 'react', 'redux', 'node', 'express', 'mui', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-rick-and-morty.netlify.app',
    repository: 'https://github.com/NazarenoCarlesso/rick-and-morty'
  },
  // {
  //   title: 'Heroes Single Page App',
  //   description: 'Everything about the superheroes that appear in your favorite comics from the different franchises',
  //   gif: 'img/heroes-spa.gif',
  //   techs: ['javascript', 'react', 'html5', 'css3', 'netlify'],
  //   deploy: 'https://nazarenocarlesso-heroes-spa.netlify.app',
  //   repository: 'https://github.com/NazarenoCarlesso/heroes-spa'
  // },
  {
    title: 'Showcase Movies',
    description: 'React technical interview with focus on useRef, useMemo, useCallback hooks',
    gif: 'img/showcase-movies.gif',
    techs: ['javascript', 'react', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-movies.netlify.app',
    repository: 'https://github.com/NazarenoCarlesso/search-movies'
  },
  {
    title: 'React Jeans Store',
    description: 'React technical interview with focus on useContext, useReducer, useId hooks',
    gif: 'img/react-store.gif',
    techs: ['javascript', 'react', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-react-store.netlify.app',
    repository: 'https://github.com/NazarenoCarlesso/react-store'
  },
  {
    title: 'Gif Explorer',
    description: 'Website to search for GIFs using the Giphy API',
    gif: 'img/gif-explorer.gif',
    techs: ['javascript', 'react', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-gif-explorer.netlify.app',
    repository: 'https://github.com/NazarenoCarlesso/gif-explorer'
  },
  {
    title: 'Journal App',
    description: 'Journal where you can save notes and images to be stored in firebase',
    gif: 'img/journal-app.gif',
    techs: ['firebase', 'javascript', 'react', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-journal-app.netlify.app/',
    repository: 'https://github.com/NazarenoCarlesso/journal-app'
  },
  {
    title: 'Infinite Cats',
    description: 'React technical interview with focus on data fetching and custom hooks + infinite scroll',
    gif: 'img/infinite-cats.gif',
    techs: ['javascript', 'react', 'html5', 'css3', 'netlify'],
    deploy: 'https://nazarenocarlesso-infinite-cats.netlify.app',
    repository: 'https://github.com/NazarenoCarlesso/cat-facts'
  },
]

export const certifications = [
  {
    title: 'Fullstack Developer',
    image: 'img/henry.jpg',
    platform: 'Henry',
    duration: 800,
    link: 'https://certificates.soyhenry.com/new-cert?id=14cd6ac27770b6ac5955016b91a4c355377b00413e69d4b80397d37d0d116024'
  },
  {
    title: 'Node: De cero a experto',
    image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-7bf99d60-dc17-4fb7-8193-d5bc5fe2bd2a.jpg?v=1648223736000',
    platform: 'Udemy',
    duration: 29,
    link: 'https://www.udemy.com/certificate/UC-7bf99d60-dc17-4fb7-8193-d5bc5fe2bd2a/'
  },
  {
    title: 'React: De cero a experto',
    image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-75fda789-c3f1-48ff-8cb9-57252b59fcef.jpg',
    platform: 'Udemy',
    duration: 54,
    link: 'https://www.udemy.com/certificate/UC-75fda789-c3f1-48ff-8cb9-57252b59fcef/'
  },
  {
    title: 'JavaScript Moderno: Guía para dominar el lenguaje',
    image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-6611fa71-4738-4f21-b608-b7c99c5d20a8.jpg?v=1648645600000',
    platform: 'Udemy',
    duration: 27.5,
    link: 'https://www.udemy.com/certificate/UC-6611fa71-4738-4f21-b608-b7c99c5d20a8/'
  },
  {
    title: 'GIT+GitHub: Todo un sistema de control de versiones de cero',
    image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-90d30d39-8e87-4bf1-be66-c531c2e8fc5f.jpg?v=1649104647000',
    platform: 'Udemy',
    duration: 12,
    link: 'https://www.udemy.com/certificate/UC-90d30d39-8e87-4bf1-be66-c531c2e8fc5f/'
  },
  {
    title: 'EF SET English Certificate 77/100 (C2 Proficient)',
    image: 'img/efset.png',
    platform: 'EF SET',
    duration: null,
    link: 'https://www.efset.org/cert/KaKBBr'
  },
  {
    title: 'Become a Back-End Web Developer',
    image: 'img/backend.png',
    platform: 'Linkedin',
    duration: 22,
    link: 'https://www.linkedin.com/learning/certificates/ca25a34fc6fa5642b9905a136ab5cc72902cc3c1b39c301bfdede2d1f567a112'
  }
]

export const badges = {
  javascript: "https://img.shields.io/badge/Javascript-black.svg?style=flat-square&logo=javascript&logoColor=%23F7DF1E",
  react: "https://img.shields.io/badge/React-black.svg?style=flat-square&logo=react&logoColor=%2361DAFB",
  redux: "https://img.shields.io/badge/Redux-black.svg?style=flat-square&logo=redux&logoColor=%23593d88",
  node: "https://img.shields.io/badge/NodeJS-black?style=flat-square&logo=node.js&logoColor=%68a063",
  express: "https://img.shields.io/badge/Express-black.svg?style=flat-square&logo=express&logoColor=%2361DAFB",
  mui: "https://img.shields.io/badge/MaterialUI-black.svg?style=flat-square&logo=mui&logoColor=%230081CB",
  html5: "https://img.shields.io/badge/HTML5-black.svg?style=flat-square&logo=html5&logoColor=%23E34F26",
  css3: "https://img.shields.io/badge/CSS3-black.svg?style=flat-square&logo=css3&logoColor=%231572B6",
  netlify: "https://img.shields.io/badge/Netlify-black.svg?style=flat-square&logo=netlify&logoColor=#00C7B7",
  postgre: "https://img.shields.io/badge/Postgres-black.svg?style=flat-square&logo=postgresql&logoColor=%23316192",
  sequelize: "https://img.shields.io/badge/Sequelize-black?style=flat-square&logo=Sequelize&logoColor=%52B0E7",
  vercel: "https://img.shields.io/badge/Vercel-black.svg?style=flat-square&logo=vercel&logoColor=%ededed",
  jwt: "https://img.shields.io/badge/JWT-black?style=flat-square&logo=JSON%20web%20tokens",
  firebase: "https://img.shields.io/badge/Firebase-black.svg?style=flat-square&logo=firebase",
}